<div class="account-wrap">
    <div class="acct-details">
        <div class="acct-title">Company Name</div>
        <div class="acct-value">{{submitAccountDetails?.companyName }}</div>
    </div>
    <div class="acct-details">
        <div class="acct-title">Company Number</div>
        <div class="acct-value">{{submitAccountDetails?.companyNo }}</div>
    </div>
    <div class="acct-details">
        <div class="acct-title">Location</div>
        <div class="acct-value">{{submitAccountDetails?.companyNo }}</div>
    </div>
</div>

<div class="account-wrap">
    <div class="acct-details">
        <div class="acct-title">Report Name</div>
        <div class="acct-value"></div>
    </div>
    <div class="acct-details">
        <div class="acct-title">Period Covered</div>
        <div class="acct-value">{{submitAccountDetails?.reportStartdate | date: "dd-LLL-yyyy" }}- {{submitAccountDetails?.reportEndDate | date: "dd-LLL-yyyy" }}</div>
    </div>
    <div class="acct-details">
        <div class="acct-title">Director Sign Date</div>
        <div class="acct-value">{{submitAccountDetails?.directorSigndate | date: "dd-LLL-yyyy" }}</div>
    </div>
    <!-- <div class="acct-details">
        <div class="acct-title">Accountant Sign Date</div>
        <div class="acct-value">25/02/2025</div>
    </div> -->
</div>

<div class="account-wrap">
    <div class="acct-details">
        <div class="acct-title">Company Auth Code</div>
        <div class="acct-value">{{gatewayDetails?.companyAuthorisationId }}</div>
    </div>
    <div class="acct-details">
        <div class="acct-title">User ID</div>
        <div class="acct-value">{{gatewayDetails?.presenterId }}</div>
    </div>
    <div class="acct-details">
        <div class="acct-title">Email</div>
        <div class="acct-value">{{gatewayDetails?.email }}</div>
    </div>
</div>